import request from '@/utils/request';

// 位置筛选
export function filterQuery(data) {
    return request({
        url: '/cscommunity/listForCsscreen',
        method: 'post',
        data: data
    });
}

export function filterQuerySale(data) {
    return request({
        url: '/cscommunity/xCommlistForCsMap',
        method: 'post',
        data: data
    });
}
// 更新地图分享
export function updateShare(data) {
    return request({
        url: '/mapShare/edit',
        method: 'post',
        data
    });
}

// 地图分享
export function mapShare(data) {
    return request({
        url: '/mapShare/add',
        method: 'post',
        data
    });
}

// 地图分享搜索
export function mapShareList(data) {
    return request({
        url: '/mapShare/list',
        method: 'get',
        params: data
    });
}
// 地图搜索
export function mapQuery(data) {
    return request({
        url: '/cscommunity/listForCsMap',
        method: 'get',
        params: data
    });
}

// 多边形打点-客服
export function listForMap(data) {
    return request({
        url: '/cscommunity/listForMap',
        method: 'get',
        params: data
    });
}

// 地图搜索(销售地图)
export function mapQuerySale(data) {
    return request({
        url: '/zyzMedium/listForCsMap',
        method: 'get',
        params: data
    });
}

// 多边形打点-销售
export function zyzlistForMap(data) {
    return request({
        url: '/zyzMedium/listForMap',
        method: 'get',
        params: data
    });
}

// 社区详细
export function csProjdetail(data) {
    return request({
        url: '/cscommunity/detailForCsMap',
        method: 'post',
        params: data
    });
}
// 社区详细(销售地图)
export function csProjdetailSale(data) {
    return request({
        url: '/cscommunity/allDetailForCsMap',
        method: 'post',
        params: data
    });
}

// 转入方案
export function intoPlan(data) {
    return request({
        url: '/design/addMapCommInDesign',
        method: 'post',
        params: data
    });
}

// 获取方案列表
export function getPlanList(data) {
    return request({
        url: '/design/listDesignByDate',
        method: 'get',
        params: data
    });
}

// 智能投放行业标签
export function getDataLabel(params) {
    return request({
        url: '/baiduPoi/getDataLabel',
        method: 'get',
        name: "xdApi",
        params
    });
}

// 获取热门标签
export function getHotLabel(params) {
    return request({
        url: '/baiduPoi/getHotLabel',
        method: 'get',
        name: "xdApi",
        params
    });
}

// 获取热力图数据
export function getHotMap(params) {
    return request({
        url: '/baiduPoi/getHotMap',
        method: 'get',
        name: "xdApi",
        params
    });
}

// 获取人群数据
export function getPopulationData(params) {
    return request({
        url: '/population/listData',
        method: 'get',
        name: 'xdApi',
        params
    });
}

export function listDataForFw(params) {
    return request({
        url: '/population/listDataForFw',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 地理编码 - 根据名称获取经纬度
export function getLat(params) {
    return request({
        url: '/community/getLat',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 逆地理编码 - 根据经纬度获取地址
export function getLoc(params) {
    return request({
        url: '/community/getLoc',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 地理位置搜索
export function getPois(params) {
    return request({
        url: '/community/getPois',
        method: 'get',
        name: 'xdApi',
        params
    });
}

